import { endpoints } from '@api'
import { Button, HStack, Text } from '@chakra-ui/react'
import { Check } from '@components/icons'
import React from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'

const JoinWaitList = ({
  width = '164px',
  height = '40px',
  feature = 'ai_notetaker',
  buttonText = 'Join waitlist',
  fontSize = '14px',
  variant = 'outline',
  'data-click-text': dataClickText = 'Join WaitList'
}) => {
  const queryClient = useQueryClient()

  const { data: featureWaitlists, isLoading } = useQuery(
    endpoints.getFeatureWaitlist.getCacheId(),
    endpoints.getFeatureWaitlist.request
  )

  const { mutateAsync: joinWaitlist, isLoading: isJoining } = useMutation(
    endpoints.postJoinWaitlist.request,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(endpoints.getFeatureWaitlist.getCacheId())
      }
    }
  )
  const onJoinWaitlist = async () => {
    await joinWaitlist({ feature })
  }

  if (isLoading) return null

  const waitListRequested = featureWaitlists.includes(feature)

  if (waitListRequested) {
    return (
      <HStack color="#A1A1A1" h={height}>
        <Check fill="#A1A1A1" />
        <Text fontSize={fontSize}>Early access requested</Text>
      </HStack>
    )
  } else {
    return (
      <Button
        width={width}
        isFullWidth={!width}
        h={height}
        fontWeight="430"
        fontSize={fontSize}
        m={0}
        variant={variant}
        isLoading={isJoining}
        onClick={onJoinWaitlist}
        _focus={{
          outline: 'none'
        }}
        _hover={
          variant === 'outline'
            ? {
                bg: 'rgba(45, 84, 232, 0.04) '
              }
            : undefined
        }
        data-click-text={dataClickText}
      >
        {buttonText}
      </Button>
    )
  }
}

export default JoinWaitList
